// For use with @techstyle/react-components ProductListingFilter `colorSwatches` prop
export const colorSwatches = {
  'Berry Blast': '#7C3766',
  'Blue Lagoon': '#418987',
  'Caribbean Blue': '#205366',
  'Cashmere Pink': '#ee7da6',
  'Ceil Blue': '#779dd7',
  'Classic White': '#EDF4FF',
  'Desert Shadows': '#776C6B',
  'Electric Teal': '#008799',
  'Elemental Blue': '#5E7892',
  'Galaxy Blue': '#212193',
  'Goji Red': '#be222f',
  'Heather Grey': '#939393',
  'Heather Pink': '#F7BCD3',
  'Holly Berry': '#7F1C25',
  'Hunter Green': '#395743',
  'Moonlight Mauve': '#7E535C',
  'Pink Marshmallow': '#E2AECB',
  'Royal Blue': '#194B82',
  'Surgical Green': '#00AE8A',
  'Utility Green': '#5B5645',
  Acai: '#45334E',
  Black: '#000',
  Blue: '#1a77c6',
  Bonsai: '#46473F',
  Brown: '#c15d07',
  Chai: '#B5A08B',
  Coral: '#FA9A98',
  Gelato: '#C7536A',
  Green: '#87ad56',
  Grey: '#858583',
  Hibiscus: '#A42662',
  Lilac: '#B88AAC',
  Navy: '#252C51',
  Onyx: '#4B4C4E',
  Orange: '#ff8c4a',
  Pink: '#eab7b7',
  Purple: '#c869f4',
  Red: '#ff1133',
  Sage: '#768981',
  Seaside: '#6DCACE',
  Ultraviolet: '#543a99',
  Wave: '#6193A3',
  White: '#fff',
  Wine: '#751c28',
  Wisteria: '#676693',
  Yellow: '#ffff00',
};
